import { useEffect } from 'react'

const PIXEL_ID = '24929880853286462'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

function initPixel() {
  if (initialized) return
  initialized = true

  try {
    if (typeof window === 'undefined') return

    const f = window as any
    if (f.fbq) return

    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script') as HTMLScriptElement
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    window.fbq('init', PIXEL_ID)
  } catch (e) {
    console.warn('Meta Pixel failed to initialize:', e)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    try {
      initPixel()
      if (window.fbq) {
        window.fbq('track', 'PageView')
      }
    } catch (e) {
      console.warn('Meta Pixel PageView failed:', e)
    }
  }, [])
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Protocolo de Pausa',
        content_type: 'product',
        value: 27,
        currency: 'USD',
      })
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}
